<script lang="ts">
    import { onMount } from 'svelte';

    import { getTransitionData } from './helper';

    import type { TransitionEffect } from '$lib/types/Theme';

    export let delay = 0;
    export let effect: TransitionEffect = 'default';
    export let fullHeight = false;

    let ready = false;

    onMount(() => (ready = true));

    const { transitionFunction, transitionProps } = getTransitionData(effect);
</script>

{#if ready}
    <div
        class:fun-h-full={fullHeight}
        in:transitionFunction={{ ...transitionProps, delay: effect === 'none' ? 0 : delay }}
    >
        <slot />
    </div>
{/if}
